import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationEnd, RoutesRecognized } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { JhiLanguageHelper, StateStorageService, Principal } from '../../shared';
import { EventManager} from 'ng-jhipster';

import { School, SchoolService} from '../../entities/school';

@Component({
    selector: 'jhi-main',
    templateUrl: './main.component.html'
})
export class JhiMainComponent implements OnInit, OnDestroy {

    currentUserSubscriber: Subscription;
    accountSubscriber: Subscription;
    colorSubscriber: Subscription;
    logoutSubscriber: Subscription;
    color: string;

    constructor(
        private jhiLanguageHelper: JhiLanguageHelper,
        private router: Router,
        private $storageService: StateStorageService,
        private eventManager: EventManager,
        private principal: Principal,
        private schoolService: SchoolService
    ) { }

    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
        let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'jYoguiApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    }

    ngOnInit() {
        this.loadAccountConfig();

        this.currentUserSubscriber = this.eventManager
                                        .subscribe('authenticationSuccess',
                                        (res) => {
                                            this.principal.identity().then((account) => {
                                                this.schoolService.findCurrent()
                                                .subscribe(school => {
                                                    this.loadAccountConfig();
                                                });
                                            });
                                        });

        this.colorSubscriber = this.eventManager
                              .subscribe('backgroundColorModification',
                              (res) =>  this.color = '#' + res.content );

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.jhiLanguageHelper.updateTitle(this.getPageTitle(this.router.routerState.snapshot.root));
            }
            if (event instanceof RoutesRecognized) {
                let params = {};
                let destinationData = {};
                let destinationName = '';
                let destinationEvent = event.state.root.firstChild;
                if (destinationEvent !== undefined) {
                    params = destinationEvent.params;
                    destinationData = destinationEvent.data;
                    destinationName = destinationEvent.url.length && destinationEvent.url[0].path;
                }
                let from = { name: this.router.url.slice(1) };
                let destination = { name: destinationName, data: destinationData };
                this.$storageService.storeDestinationState(destination, params, from);
            }
        });
    }

    ngOnDestroy() {
        this.currentUserSubscriber.unsubscribe();
        this.accountSubscriber.unsubscribe();
        this.colorSubscriber.unsubscribe();
        this.logoutSubscriber.unsubscribe();
    }

    private loadAccountConfig() {
        this.color =  this.schoolService.getColor('background');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/main/main.component.ts